import React, { useEffect, useMemo, useState } from "react";
import Table from "../../../components/Table";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setAuthorize } from "../../../actions/app-action-types";
import Icon from "../../../components/Icon";
import { TENANTS } from "../../../constant";
import { Circle } from "../../../components/Overlay";
import { MainPagesPath } from "../../../routing/Paths";
import styled from "styled-components";
import SelectInputBox from "../../../components/SelectInputBox";
import { Typography } from "@mui/material";
import useGetMachineFeatureMapping from "../../../hooks/useGetMachineFeatureMapping";
import { get } from "lodash";

////********Styled Components ********************/
const MainContainer = styled.div`
  padding: 20px 40px;
  overflow: hidden;
  .textTruncate {
    font-family: "Roboto-Regular";
    font-size: 12px;
    color: rgb(81, 83, 83);
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 110px;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const LoaderContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  align-items: center;
`;

const MachineModels = ({ visible }) => {
  const [tenantId, setTenantId] = useState("AG");

  const { fetchMachineFeatureMapping, modelsList } =
    useGetMachineFeatureMapping();

  useEffect(() => {
    fetchMachineFeatureMapping();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      Header: "Sl No.",
      accessor: "srNo",
      maxWidth: 50,
    },
    {
      Header: "Actions",
      accessor: "modelId",
      Cell: (data) => {
        const modelName = get(data, "row.values.modelName") ?? "";
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                marginRight: "8px",
                marginLeft: "8px",
                cursor: "pointer",
              }}
            >
              <Link to={`${MainPagesPath.modelDetails}/${modelName}`}>
                <Icon icon="edit" />
              </Link>
            </div>
          </div>
        );
      },
      maxWidth: 80,
    },
    {
      Header: "Model Name",
      accessor: "modelName",
      maxWidth: 120,
    },
    {
      Header: "Model Description",
      accessor: "modelDesc",
      maxWidth: 120,
    },
    {
      Header: "Variant Count",
      accessor: "variants",
      maxWidth: 80,
      Cell: (row) => {
        const variants = get(row, "value") ?? [];
        return <Typography variant="caption">{variants.length}</Typography>;
      },
    },
    {
      Header: "HP",
      accessor: "enginePower",
      maxWidth: 120,
    },
    {
      Header: "Product",
      accessor: "productName",
      maxWidth: 120,
    },
  ];

  const tableData = useMemo(() => {
    return (
      modelsList?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || []
    );
  }, [modelsList]);

  return (
    <>
      <MainContainer>
        <Typography
          variant="h5"
          fontWeight={700}
          color={"#003E85"}
          marginBottom={2}
        >
          {"Machine Models"}
        </Typography>
        <FilterContainer>
          <SelectInputBox
            value={tenantId}
            options={Object.values(TENANTS)}
            label={"Tenant"}
            style={{ width: 200 }}
            onChange={(e) => setTenantId(e.target.value)}
          />
        </FilterContainer>
        <Table
          stickyHeader={true}
          columns={columns}
          data={tableData}
          defaultPageSize={10}
          filterSearchTop={"34px"}
          headerZIndex={1}
        />
      </MainContainer>
      {visible && (
        <LoaderContainer>
          <Circle size="Large" />
        </LoaderContainer>
      )}
    </>
  );
};

const mapStateToProps = ({
  app: { visible, isUnauthorize },
  schemes: { syncObject },
}) => ({
  visible,
  syncObject,
  isUnauthorize,
});

export default connect(mapStateToProps, {
  setAuthorize,
})(MachineModels);
